export enum CreamTypes {
    SUN = 'SUN',
    REG = 'REG',
}
